import React from "react";
import { useAccessStore } from "../lib/store/useAccessStore"
import { jwtDecode } from "jwt-decode";

export const useLoginInfo = () => {
    const { access, clearAccess } = useAccessStore();
    
    const isLoggedIn = React.useMemo(() => {
        if (!access.accessToken) return false;
        
        try {
            const decodedToken = jwtDecode(access.accessToken);
            const isExpired = (decodedToken.exp || 0) * 1000 < Date.now();

            return !isExpired
        } catch (error) {
            console.error("Invalid token:", error);
            return false;
        }
    }, [access.accessToken])

    return {
        isLoggedIn,
        logout: clearAccess
    }
}